module.exports = __webpack_public_path__ + "img/glasgowicon.9e70fb63.png";